import { defineComponent as p, inject as v, withDirectives as N, cloneVNode as g, Comment as f, Fragment as w, Text as C, createVNode as O } from "vue";
import { FORWARD_REF_INJECTION_KEY as R, useForwardRefDirective as y } from "./index563.js";
import { NOOP as F, isObject as _ } from "./index575.js";
import { debugWarn as a } from "./index588.js";
import { useNamespace as E } from "./index559.js";
const o = "ElOnlyChild", b = /* @__PURE__ */ p({
  name: o,
  setup(r, {
    slots: n,
    attrs: t
  }) {
    var e;
    const i = v(R), m = y((e = i?.setForwardRef) != null ? e : F);
    return () => {
      var l;
      const c = (l = n.default) == null ? void 0 : l.call(n, t);
      if (!c) return null;
      const [u, h] = s(c);
      return u ? (h > 1 && a(o, "requires exact only one valid child."), N(g(u, t), [[m]])) : (a(o, "no valid child node found"), null);
    };
  }
});
function s(r) {
  if (!r) return [null, 0];
  const n = r, t = n.filter((e) => e.type !== f).length;
  for (const e of n) {
    if (_(e))
      switch (e.type) {
        case f:
          continue;
        case C:
        case "svg":
          return [d(e), t];
        case w:
          return s(e.children);
        default:
          return [e, t];
      }
    return [d(e), t];
  }
  return [null, 0];
}
function d(r) {
  const n = E("only-child");
  return O("span", {
    class: n.e("content")
  }, [r]);
}
export {
  b as OnlyChild
};
